import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";

function DataCentreGlobally(props) {
	const [mobile, setMobile] = useState(false)
	useEffect(() => {
		if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			setMobile({ mobile: true })
		}
	}, [])
	return (
		<div className="services-bg">
			<Container>
				<div>
					<p className={!mobile ? "header-detased text-left" : "header-detased"}>DETASAD's Global Infrastructure</p>
				</div>
				<Row>
					<Col md="4">
						<div className="data-service-card">
							<Row>
								<Col md="4">
									<img
										className="data-storage-icon"
										src={require("../../assets/Detasad Cloud/icon_storage.svg")}
										alt=""
									/>
								</Col>
								<Col md="8">
									<p className="data-card-head pt-3">Data Center Regions</p>
									<p className="data-card-body">
										Number of Regions : 04
									</p>
									<p className="data-card-body">
										Number of Availability Zones : 07
									</p>
								</Col>
							</Row>
						</div>

						<div className="data-service-card">
							<Row>
								<Col md="4">
									<img
										className="data-storage-icon"
										src={require("../../assets/Detasad Cloud/availible_ic_nodes.svg")}
										alt=""
									/>
								</Col>
								<Col md="8">
									<p className="data-card-head pt-3">Certifications</p>
									<p className="data-card-body">
										TUVIT, ISO27001, ISO9000, PCI-DSS,
									</p>
									<p className="data-card-body">
										Red Hat CSSP, SAP
									</p>
								</Col>
							</Row>
						</div>

						<div className="data-service-card">
							<Row>
								<Col md="4">
									<img
										className="data-storage-icon"
										src={require("../../assets/Detasad Cloud/availible_ic_zones.svg")}
										alt=""
									/>
								</Col>
								<Col md="8">
									<p className="data-card-head pt-3">Service-Level Agreement</p>
									<p className="data-card-body">
										DETASAD guarantees an SLA of 99.99% of its services.
									</p>
								</Col>
							</Row>
						</div>
					</Col>
					<Col md="8">
						<div className="bg-map">
							<div className="us-mark">
							</div>
						</div>
					</Col>
				</Row>
			</Container>
		</div>
	);
}

export default DataCentreGlobally;